<template>
<div class="chapter">
<div class="inner_page">
<p class="ded" id="ded"><a id="page_v"></a><em>For Senator Fritz Hollings,<br/>who fought the good fight<br/>when no one else would</em>.<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?4d0f8bc6